'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('HubStyleTokens/colors');

var _AvatarWrapper = require('./AvatarWrapper');

var _AvatarWrapper2 = _interopRequireDefault(_AvatarWrapper);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _styledComponents2.default)(_AvatarWrapper2.default).withConfig({
  displayName: 'AvatarWrapperOverlay'
})(['& .overlay-content{align-items:center;background:', ';color:', ';cursor:pointer;display:flex;font-family:sans-serif;height:0;hyphens:auto;justify-content:center;left:0;opacity:0;overflow:visible;padding:calc(50%);position:absolute;text-align:center;top:0;transition:opacity 300ms ease;width:0;}&:hover .overlay-content,&.hover-test .overlay-content{opacity:0.85;}'], _colors.SLINKY, _colors.OLAF);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.1456/js/UIAvatarDisplay/baseStyledComponents/AvatarWrapperOverlay.js
// module id = 492
// module chunks = 171